import { Self } from '@/vue-core';
import { defineComponent, ref, onMounted } from '@vue/composition-api';
export default defineComponent({
    props: {
        content: {
            type: String
        }
    },
    setup(props, context) {
        let self = new Self(context);
        // =================
        //
        // refs
        //
        let markdown = ref(null);
        onMounted(() => {
            markdown.value.$el.querySelectorAll('a').forEach(el => {
                el.addEventListener('click', () => {
                    setTimeout(() => window.scrollTo(0, window.scrollY - 100), 1);
                });
            });
        });
        // =================
        //
        // done
        //
        return {
            markdown
        };
    }
});
